module.exports = __webpack_public_path__ + "static/media/background.fd330822.png";